/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const QuantityInput = {

	$domQuantityInputPlusGlobal: $('.js-input-increment-plus'),
	$domQuantityInputMinusGlobal: $('.js-input-increment-minus'),
	$domQuantityInputGlobal: $('input[type="number"]'),
	$domInputSearch: $('#singleInputShow'),
	focusedClass: 'is-focused',
	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		if(!$('body.post-type-archive-product').length || !$('body.woocommerce-cart-form').length) {
			this.quantityNumberInput(QuantityInput.$domQuantityInputMinusGlobal);
			this.quantityNumberInput(QuantityInput.$domQuantityInputPlusGlobal);
			this.$domInputSearch.on('input', this.updateValue);
			$('.js-cart-input').on('input', this.updateValue);
			$('.js-later-input').on('input', this.updateValue);
			this.$domInputSearch.on('focus', this.handleFocus);
			this.$domInputSearch.on('blur', this.handleBlur);
			this.quantityNumberInput(QuantityInput.$domInputSearch);
		}


        const inputElement = document.getElementById('singleInputShow');
		if (inputElement) {
            inputElement.addEventListener('focus', this.handleFocus);
            inputElement.addEventListener('blur', this.handleBlur);
            inputElement.addEventListener('keyup', this.onEnter);
        }
	},

	updateValue: (event) => {
		let val = event.target.value;
		const max = event.target.maxLength;

        val = val.replace(/[^0-9]/g, '');

		if (val.length > max) {
			val = val.slice(0, max);
			/* event.target.value = val; */
		}

		// If the value is empty, treat it as 0 internally
        if (val === '') {
			val = '0';
		}

		event.target.value = val;
	},

	// Function to handle focus on the input
    handleFocus: function(event) {
        const inputElement = event.target;
        $(inputElement).addClass(QuantityInput.focusedClass);

        // If the value is '0', clear the input
        if ($(inputElement).val() === '0') {
            $(inputElement).val('');
        }
    },

    // Function to handle blur (focus out) on the input
    handleBlur: function(event) {
        const inputElement = event.target;
        $(inputElement).removeClass(QuantityInput.focusedClass);

        // If the input is empty on blur, set it to '0'
        if ($(inputElement).val().trim() === '') {
            $(inputElement).val('0');
        }
    },

	quantityNumberInput: ($selector) => {
		$selector.each(function(e, el) {
			// Detects if plus or minus was clicked, and increments or decrements the input value
			// $(el).on('click', function(e) {
			// 	const $this = $(e.currentTarget);
			// 	const input = $this.parent().find('input');
			// 	const inputNum = $this.parent().find('input').val();
			// 	const currentValue = $this.parent().find('input').val();
			// 	if (e.target.classList.contains('js-input-increment-plus')) {
			// 		const inputNum = parseInt($this.parent().find('input').val());
			// 		input.val(isNaN(inputNum) ? 1 : inputNum + 1);
			//
			// 	} else if (e.target.classList.contains('js-input-increment-minus')) {
			// 		input.val(parseInt(inputNum) - 1);
			// 		if (currentValue <= 1) {
			// 			$this.parent().find('input').val(1);
			// 		}
			// 	}
			// });
			// Stops user from typing in numbers, that are not allowed
			$(el).parent().find('input').on('input', function() {
				const currentValue = $(this).val();
				const maxValue = $(this).attr('max');
				if ($(this).val() < 0 && $(this).val() === 0) {
					$(this).val('');
				} else if (currentValue > maxValue - 1) {
					$(this).val(maxValue);
				}
			});
		});
	},

	onEnter: function(event) {
        let val = event.target.value.trim() === '' ? 0 : parseInt(event.target.value) || 0;
        // Treat empty value as 0 internally
        if (val.trim() === '') {
            event.target.value = '0';
        }

		if (val < 0) {
			event.target.value = ''; // Keep it visually empty
		}
    }
};

export default QuantityInput;
